import React from "react";
import { Link } from "react-router-dom";
import FooterLogo from "../images/jhatpat-nbfc-logo.png";
import logo from "../images/jhatpat-logo.png";
import {
    Phone,
    Mail,
    MapPin,
    ArrowUp,
    AlignCenter
} from "lucide-react";
import "./Footer.css";
import { CONTACT_EMAIL, CONTACT_NUMBER } from "../Utils/constant";

const Footer = () => {
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" }); 
    };

    return (
        <div>
            <footer className="modern-footer">
                {/* Hero Section */}
                <div className="footer-hero">
                    <div className="hero-content">
                        <div className="company-brand">
                            {/* <div className="brand-logo">
                                <img src={logo} alt="Udhaar Portal Logo" />
                            </div> */}
                            {/* <div className="brand-info">
                                <h2>Udhaar Portal</h2>
                                <p>Instant Financial Solutions</p>
                                <span className="brand-tagline">
                                    Empowering individuals with instant financial solutions through 
                                    advanced technology and customer-centric approach.
                                </span>
                            </div> */}
                        </div>
                        
                        {/* Partners Section */}
                        {/* <div className="partners-showcase">
                            <div className="partner-card lending-partner">
                                <div className="partner-header">
                                    <span className="partner-badge">Lending Partner</span>
                                </div>
                                <div className="partner-logo">
                                    <img src={FooterLogo} alt="Loan2 Grow Logo" />
                                </div>
                                <a href="https://www.l2gfincap.in/" target="_blank" rel="noopener noreferrer" className="partner-link">
                                    Visit Website →
                                </a>
                            </div>
                            
                            <div className="partner-card associated-partner">
                                <div className="partner-header">
                                    <span className="partner-badge">Associated Partner</span>
                                </div>
                                <div className="partner-name">
                                    <a href="https://fintechcloud.in/" target="_blank" rel="noopener noreferrer">
                                        Arthsarita Advisors Private Limited
                                    </a>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>

                {/* Main Footer Content */}
                <div className="footer-content">
                    <div className="footer-grid">
                        {/* Quick Access */}
                        <div className="footer-section">
                            <h3>Quick Access</h3>
                            <ul className="footer-links">
                                <li><Link to="/" onClick={scrollToTop}>Home</Link></li>
                                <li><Link to="/about-us" onClick={scrollToTop}>About Us</Link></li>
                                <li><Link to="/contact" onClick={scrollToTop}>Contact</Link></li>
                                <li><Link to="/faq" onClick={scrollToTop}>FAQs</Link></li>
                            </ul>
                        </div>

                        {/* Legal */}
                        <div className="footer-section">
                            <h3>Legal</h3>
                            <ul className="footer-links">
                                <li><Link to="/privacy-policy" onClick={scrollToTop}>Privacy Policy</Link></li>
                                <li><Link to="/terms-condition" onClick={scrollToTop}>Terms & Conditions</Link></li>
                                <li><Link to="/security-alert" onClick={scrollToTop}>Security Alert</Link></li>
                                <li><Link to="/apply-now" onClick={scrollToTop}>Apply Now</Link></li>
                                <li><Link to="/repayloan" onClick={scrollToTop}>Repay Loan</Link></li>
                                <li><a target="_blank" rel="noopener noreferrer" onClick={scrollToTop}>Other Policies</a></li>
                            </ul>
                            <div className="nbfc-partner-section">
                                <h4 className="nbfc-section-title">NBFC Partner</h4>
                                <a target="_blank" rel="noopener noreferrer" className="nbfc-btn">
                                    <span className="nbfc-text">Focus Industrial Resources Limited</span>
                                    <span className="nbfc-arrow">→</span>
                                </a>
                            </div>
                        </div>

                        {/* Contact Info */}
                        <div className="footer-section contact-info">
                            <h3>Get In Touch</h3>
                            <div className="contact-items">
                                <div className="contact-item">
                                    <Phone className="contact-icon" />
                                    <div>
                                        <span className="contact-label">Call Us</span>
                                        <span className="contact-value">09311437690</span>
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <Mail className="contact-icon" />
                                    <div>
                                        <span className="contact-label">Email Us</span>
                                        <span className="contact-value">contact@udhaarportal.com</span>
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <MapPin className="contact-icon" />
                                    <div>
                                        <span className="contact-label">Address</span>
                                        <span className="contact-value">15 Sant Nagar, East of Kailash, New Delhi - 110065</span>
                                    </div>
                                </div>
                            </div>
                            
                            {/* NBFC Partner Section */}
                       
                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="footer-bottom">
                    <div className="footer-bottom-content">
                        <p>Copyright@Udhaar Portal. Powered by Unifin Experts LLP</p>
                        <div className="footer-actions">
                            <button className="scroll-top-btn" onClick={scrollToTop}>
                                <ArrowUp className="icon" />
                                Back to Top
                            </button>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Footer;
